/* 🤖 this file was generated by svg-to-ts */
export const nsEdit: {
  name: 'edit';
  data: string;
} = {
  name: 'edit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M2 16.25V20h3.75L16.81 8.94l-3.75-3.75L2 16.25ZM4.92 18H4v-.92l9.06-9.06.92.92L4.92 18ZM19.71 4.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29-.26 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41Z" clip-rule="evenodd"/></svg>`
};
